<div *ngIf="images?.length">
  <img class="details-image" [src]="currImage" alt="main image" />
  <div class="thumbnails-block">
    <img class="thumbnail-img" *ngFor="let src of images" [src]="src" alt="thumbnail" (click)="setCurrent(src)" />
  </div>
</div>
